module.exports = __webpack_public_path__ + "static/media/record-reset-icon.57635d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/record-reset-icon.svg
// module id = ./src/assets/images/record-reset-icon.svg
// module chunks = 0